import {type Line} from '../../../util/plotHelpers/types';
import {type AlignmentProfileState, getAlignedData} from './getAlignedData';
import {getSeriesEntries} from './getSeriesEntries';

/** Own one alignment per panel revision; chart instances only read these arrays. */
export function prepareUPlotData(
  lines: Line[],
  xLogScale?: boolean,
  profile?: AlignmentProfileState
) {
  const entries = getSeriesEntries(lines);
  return {
    ...entries,
    data: getAlignedData(entries.seriesEntries, xLogScale, profile),
  };
}

export type PreparedUPlotData = ReturnType<typeof prepareUPlotData>;
